// extracted by mini-css-extract-plugin
export var stickyWrapperStyle = "template_landing_page_event-module--stickyWrapperStyle--W3eq8";
export var textContainerStyle = "template_landing_page_event-module--textContainerStyle--bIsgW";
export var twoColumnLayoutStyle = "template_landing_page_event-module--twoColumnLayoutStyle--x4K2f";
export var wrapperStyle = "template_landing_page_event-module--wrapperStyle--a7Bzk";